import { defineComponent as _defineComponent } from 'vue'
import { saveHistory } from '@/apis/common/saveHistory'
import { fetchGetProductionNcSetting } from '@/apis/materialList'
import GBaseModal from '@/components/g-base-modal.vue'
import GFolderChooseModal from '@/components/g-folder-choose-modal.vue'
import GWarningModal from '@/components/g-warning-modal.vue'
import virtualList from '@/components/materialTable'
import { productionFillManageList } from '@/components/materialTable/src/config/tableConfig'
import router from '@/router'
import store from '@/store'
import type { PreferencesSetting } from '@/store/modules/preferencesSetting/types'
import { translate } from '@/util/commonFun'
import { buryPointApi } from '@/util/commonFuncs'
import { fileNameSetObj } from '@/util/configure'
import jszip from '@/util/jszip'
import {
  encodeOssUrl,
  genMergeSubFolderData,
  promiseToZip,
} from '@/util/saveFile'
import { saveDataToOSS } from '@/util/saveFile'
import {
  downloadFile as downloadNCFile,
  mergeFolder,
} from '@/views/newPaiban/util/downLoadNC'
import {
  genFinalDataOrder,
  getPaibanDataTotalArea,
} from '@/views/newPaiban/util/layoutDataDeal'
import {
  isSpecialBigPlank,
  isSurplusBigPlank,
} from '@/views/newPaiban/util/layoutDataDeal'
import axios from 'axios'
import { Message } from 'element-ui'
import { Notification } from 'element-ui'
import { nanoid } from 'nanoid'
import { computed, reactive, ref, set } from 'vue'
import Vue from 'vue'

import MTemplate from './components/m-template.vue'
import { productSearchKeys } from './config'

export type ListItem = {
  isSelect: boolean
  id: number
  uid: number
  address: string
  order_id: string
  product_line: string
  product_data: string
  file_url: string
  plank_url: string
  create_time: string
  partUniqueId: string
  process_line_id: number
}
type Search = { searchKey: string; current: number; pageSize: number }


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const state = reactive({
  productList: [] as ListItem[],
  total: 0,
  page: { current: 1, pageSize: 10, searchKey: '' },
  searchType: 1,
})
const isLoading = ref(false)
const isFileDownLoad = ref(false)
let isBatchDownLoad = ref(false)
// 删除弹窗是否可见
const isVisible = ref(false)
// 删除的文件数组
const deleteList = ref<ListItem[]>([])
const allSelect = computed(
  () =>
    state.productList.every((it) => it.isSelect) && !!state.productList.length
)
const ListLen = computed(() => !state.productList.length)
// 获取已选中
const alreadySelect = computed(() =>
  state.productList.filter((it) => it.isSelect)
)
let repeatNameList = ref([]) as any //重名数组
let repeatFileNameList = ref([]) as any
let repeatFolderNameList = ref([]) as any
let isShowWarningModal = ref(false)
let currentIndex = ref(0)
let currentPage = ref(0)
const folderChooseModalRef = ref<any>(null)
const currentRow = ref<any>(null)
// 目录选择后执行的回调
const folderExeCb = ref<any>(null)

/** 车间翻译函数 */
function t(k: string, val?: any) {
  return translate('workShopPage.' + k, val)
}
/** 通用翻译函数 */
function ct(k: string, val?: any) {
  return translate('common.' + k, val)
}

// 刷新
function handleReload() {
  state.page = { current: 1, pageSize: 10, searchKey: '' }
  getProductionFileList()
}
// 搜索
function onSearch({
  value,
  selectType,
}: {
  value: Search
  selectType: string
}) {
  state.searchType = +selectType
  getProductionFileList(value)
}
// 获取生产文件列表
function getProductionFileList(value?: Search) {
  const search = getSearchInfo(value ?? { ...state.page })
  isLoading.value = true
  Vue.prototype.$getByToken('/workshop/files', search, (res: any) => {
    if (res.status === 1) {
      state.productList = genPartUniqueId(res.data.data)
      state.total = res.data.total
    } else {
      Message.error(res.msg ?? ct('requestFail'))
    }
    isLoading.value = false
  })
}
// 请求数据
getProductionFileList()

// 删除
function handleDeleteFile(value: ListItem[] | ListItem) {
  if (!Array.isArray(value)) {
    value = [value]
    buryPointApi('device_online', 'delete_plate')
  } else {
    buryPointApi('device_online', 'batch_delete_plate')
  }
  deleteList.value = value
  isVisible.value = true
}
// 确认删除
function handleConfrimDetale() {
  let value = deleteList.value
  if (!Array.isArray(value)) {
    value = [value]
  }
  const ids = value.map((it) => it.id)
  Vue.prototype.$request(
    `/workshop/files/${ids.join(',')}`,
    {
      method: 'DELETE',
    },
    (res: any) => {
      if (res.status === 1) {
        // 数据中删除对应数据，如数据项为0则刷新页面重新请求
        state.productList = state.productList.filter(
          (it) => !ids.includes(it.id)
        )
        if (!state.productList.length) {
          handleReload()
        }
        /** 删除成功 */
        Message.success(ct('deleteSuccess'))
      } else {
        Message.error(res.msg)
      }
    }
  )
  isVisible.value = false
}
// 触发所有点击
function onAllSelectChange() {
  const flag = !allSelect.value
  state.productList.forEach((it) => (it.isSelect = flag))
}
// 生成唯一标识ID
function genPartUniqueId(list: ListItem[]) {
  list.forEach((it) => {
    set(it, 'isSelect', false)
    it.partUniqueId = nanoid()
  })
  return list
}
// 处理查询信息
function getSearchInfo(searchInfo: Search) {
  const { searchKey, current, pageSize } = searchInfo
  return {
    filter_word: searchKey,
    page: current,
    limit: pageSize,
    filter_type: state.searchType,
  }
}
function handleGoToBujian({ part }: { part: ListItem }) {
  buryPointApi('device_online', 'supplement')
  // 找不到补件文件
  if (!part.plank_url) return Message.error(t('notBujianFile'))
  router.push({
    path: '/workShopProduction/bujian',
    query: {
      url: part.plank_url,
    },
  })
}
/** 单个点击下载的处理 */
async function handleClickSingleDownload(data: any) {
  currentRow.value = data
  folderExeCb.value = handleDownloadFile
  await handleDownloadFile()
}

// 下载单个文件
async function handleDownloadFile() {
  if (isFileDownLoad.value) return
  // 检查本地所使用的目录是否存在
  if (!(await folderChooseModalRef.value?.verify())) {
    return
  }
  currentIndex.value = currentRow.value.index
  currentPage.value = state.page.current
  isFileDownLoad.value = true
  buryPointApi('device_online', 'download_production')
  await downloadFile(currentRow.value)
}
async function handleDownloadNCFile(
  files: any,
  part: ListItem,
  ncSetting: any
) {
  store.commit('setFolderContents', {})
  store.commit('setRepeatFileName', [])
  store.commit('setTempFileName', [])
  store.commit('setMergeFolderSetting', {
    ...ncSetting.customizeFolder,
    process_setting_id: ncSetting.process_setting_id,
  })

  const { subfolderNameStr } =
    store.state.mergeFolderSetting ?? ncSetting.customizeFolder
  const needSizeArr = ['板件长宽', '文件数自增']
  genMergeSubFolderData(
    files,
    needSizeArr.some((item) => subfolderNameStr.includes(item)) ? true : false,
    ncSetting,
    'files'
  )
  // 找到排版图的数据
  let imgStr = ''
  files.map((item: any) => {
    if (item.fileType == 'tag') {
      imgStr = item.img_url
    }
  })
  let imgFiles = []
  let pdfArr = []
  // 拿到数据
  if (imgStr) {
    const imgRes = await new Promise<any>((resolve) => {
      axios.get(encodeOssUrl(imgStr)).then((res) => {
        resolve(res.data)
      })
    })
    imgFiles = imgRes.imgArr
    pdfArr = imgRes.pdfArr
  }
  const result = await downloadNCFile(
    files.slice(-1)[0].jsonObj !== undefined
      ? files.slice(0, files.length - 1)
      : files,
    part.address,
    imgFiles ?? [],
    pdfArr,
    false,
    part.address,
    mergeFolder,
    ncSetting,
    () => {
      isFileDownLoad.value = false
      isBatchDownLoad.value = false
    },
    files.slice(-1)[0].jsonObj !== undefined
      ? new Blob([JSON.stringify(files.slice(-1)[0].jsonObj)])
      : null
  )
  let repeatZipFolderNameList = [] as any
  const repeatZipFileNameList = JSON.parse(
    JSON.stringify(store.state.repeatFileName)
  )

  Object.keys(store.state?.folderContents)?.forEach((item) => {
    if (
      !ncSetting?.customizeFolder?.merge_folder_list.includes(
        fileNameSetObj[item] + '文件'
      ) &&
      ncSetting?.customizeFolder?.merge_folder_list.length > 1
    ) {
      if (
        ncSetting.customizeFolder.merge_folder_display_name.trim() ===
        store.state.folderContents[item].trim()
      ) {
        repeatZipFolderNameList.push(fileNameSetObj[item])
      }
    }
  })
  repeatFileNameList.value = repeatZipFileNameList
  repeatFolderNameList.value = repeatZipFolderNameList
  repeatNameList.value = []
    .concat(repeatZipFolderNameList)
    .concat(repeatZipFileNameList)
  if (repeatNameList.value.length) {
    isShowWarningModal.value = true
    isFileDownLoad.value = false
    isBatchDownLoad.value = false
    return
  }
  if (result?.zip) {
    const { zip, nameStr } = result
    await promiseToZip(
      zip,
      null,
      nameStr,
      (url: string) => [url],
      () => [],
      {},
      ncSetting
    )

    Notification.success(ct('downloadDoneByType', { type: nameStr }) + '!')
    isFileDownLoad.value = false
    isBatchDownLoad.value = false

    saveMaterialPaiban(files)
  }
}
let ncSetting = ref<any>(null)
// 下载生产文件
async function downloadFile(data: { part: ListItem }) {
  try {
    const { part } = data

    // 获取生产线设置
    const res = await fetchGetProductionNcSetting({
      setting_id: part.process_line_id,
    })

    // 生产线设置获取失败
    if (res.status !== 1) {
      Vue.prototype.$message.error(t('productLineDelete'))
      isFileDownLoad.value = false
      isBatchDownLoad.value = false
      return
    }
    ncSetting.value = res.data

    const files = (await axios.get(encodeOssUrl(part.file_url))).data.files

    if (part.product_data) {
      await downloadFullZipFile(part, files)
    } else {
      handleDownloadNCFile(files, part, {
        ...ncSetting.value,
        process_setting_id: part.process_line_id,
      })
    }
  } catch (error) {
    console.error(error)
  } finally {
    isFileDownLoad.value = false
    isBatchDownLoad.value = false
  }
}

/**
 * @description 如果存在完成 zip 数据的链接，则不走常规的下载链接，直接下载即可
 */
async function downloadFullZipFile(record: ListItem, files: any) {
  try {
    const { product_data, address } = record
    const { data } = await axios.get(encodeOssUrl(product_data), {
      responseType: 'arraybuffer',
    })
    const zip = await jszip.loadAsync(data)
    await promiseToZip(zip, null, address, null, () => [], {}, null)
    await saveMaterialPaiban(files)
    Notification.success(ct('downloadDoneByType', { type: address }) + '!')
  } finally {
    isFileDownLoad.value = false
    isBatchDownLoad.value = false
  }
}

// 批量下载
async function handleDownloadFiles() {
  // 控制批量下载
  folderExeCb.value = handleDownloadFiles
  // 检查本地所使用的目录是否存在
  if (!(await folderChooseModalRef.value?.verify())) {
    return
  }
  buryPointApi('device_online', 'download_production_multi')
  for (const item of alreadySelect.value) {
    if (item.isSelect) {
      isFileDownLoad.value = true
      isBatchDownLoad.value = true
      currentRow.value = { part: item }
      await downloadFile({ part: item })
    }
  }
  // 批量生成保存历史
}

// 从 paibanData 生成 plankList
function generatePlankListFromPaibanData(paibanData: any[]) {
  // 使用 genFinalDataOrder 处理 paibanData 生成 drawData
  const preferences: Partial<PreferencesSetting> = {
    isSurplusNoRoll: false,
    isSortByPlankCountDesc: false,
  }
  const { data: drawData } = genFinalDataOrder(
    paibanData,
    ncSetting.value || {},
    preferences as PreferencesSetting,
    false
  )

  // 记录使用到的大板类型
  let bigPlankList: any[] = []

  for (let i = 0; i < drawData.length; ++i) {
    // 记录一个订单和房间的映射列表
    let orderIdToRoomMap = new Map<any, Set<any>>()
    drawData[i].data.forEach((item: any) => {
      item.parts.forEach((part: any) => {
        if (!orderIdToRoomMap.has(part.orderId)) {
          orderIdToRoomMap.set(part.orderId, new Set())
        }
        orderIdToRoomMap.get(part.orderId)?.add(part.roomID)
      })
    })

    // 将映射转换为所需的结构
    let result: Array<{ roomID: any[]; orderId: any }> = []
    orderIdToRoomMap.forEach((roomSet, orderId) => {
      result.push({ roomID: Array.from(roomSet), orderId: orderId })
    })

    // 合并具有相同 orderId 的对象
    let finalResult: Array<{ roomID: any[]; orderId: any }> = []
    result.forEach((group) => {
      let existingGroup = finalResult.find(
        (item) => item.orderId === group.orderId
      )
      if (existingGroup) {
        existingGroup.roomID.push(...group.roomID)
        existingGroup.roomID = Array.from(new Set(existingGroup.roomID)) // 去重
      } else {
        finalResult.push(group)
      }
    })

    const drawItem = drawData[i] as any
    if (drawItem.otherPlate) {
      bigPlankList.push({
        plankInOrderRoom: finalResult,
        matCode: drawItem.matCode,
        thick: drawItem.thick,
        texture: drawItem.texture,
        num: drawItem.data.length,
        plankSize: `${drawItem.otherPlate.height}*${drawItem.otherPlate.width}`,
        otherPlankFlag: drawItem.isManual ? 1 : 0,
        doorPlankFlag: drawItem.hasDoor ? 1 : 0,
        toggleCount: drawItem.data.filter((e: any) => e.ableToggle).length,
        type: drawItem.type,
        isSpecialBigPlank: 1,
      })
    } else {
      const size = drawItem.plankHeight
        ? `${drawItem.plankHeight}*${drawItem.plankWidth}`
        : `${drawItem.data[0].plankHeight}*${drawItem.data[0].plankWidth}`
      bigPlankList.push({
        plankInOrderRoom: finalResult,
        matCode: drawItem.matCode,
        thick: drawItem.thick,
        texture: drawItem.texture,
        num: drawItem.data.length,
        toggleCount: drawItem.data.filter((e: any) => e.ableToggle).length,
        plankSize: size,
        otherPlankFlag: drawItem.isManual ? 1 : 0,
        doorPlankFlag: drawItem.hasDoor ? 1 : 0,
        type: drawItem.type,
      })
    }
  }

  return bigPlankList
}

// 保存历史
async function saveMaterialPaiban(files: any) {
  const name = `${currentRow.value.part.address}_FromWebPage_生产线(${currentRow.value.part.product_line})`
  const jsonFileName = `/bluenMaterialData/${
    store.state.userInfo.id
  }/${new Date().getTime()}_${nanoid()}.json.gz`

  // 需要在files数组中最后一项找到jsonObj
  const lastFile = files && files.length > 0 ? files[files.length - 1] : null
  const jsonObj = lastFile?.jsonObj || {}
  // const layoutData = jsonObj?.paibanData

  // 将此数据上传至oss
  const layoutDataUrl = await saveDataToOSS(
    jsonObj,
    jsonFileName,
    'bluenMaterialData'
  )

  const fileName = `filterObj_${new Date().getTime()}`
  const path = 'cloud_paiban/filterObj'
  const filterObjUrl = await saveDataToOSS(
    store.state.filterObject,
    fileName,
    path
  )
  const { totalUsedRate, totalUsedArea } = getPaibanDataTotalArea(
    jsonObj.paibanData
  )
  const { mixPaibanPlans = [] } = jsonObj.paibanInfo
  // 从 paibanData 生成 plankList
  const plankList = generatePlankListFromPaibanData(jsonObj.paibanData)
  const currentLine = store.state.proLineList.find(
    (item) => item.id === currentRow.value.part.process_line_id
  )?.data
  let obj: any = {
    name,
    plank_info: {
      historyUrl: layoutDataUrl,
      plankTypeList: plankList,
      used_rate: totalUsedRate || '',
      used_area: totalUsedArea || '',
      // hasSaveSurplus: this.hasSaveSurplus,
      process_setting_name: currentRow.value.part.product_line, // 记录生产线名字, 判断是否为默认生产线
      order_codes: store.state.orderInfo.order_codes
        ? store.state.orderInfo.order_codes
        : '',
      // isLessReverse: this.isLessReverse,
      // isSpecialShape: this.isSpecialShape,
      // paibanWay: this.activePaibanWay[0],
      // layoutMethod: this.isSpecialShape
      //   ? paibanWayStr + '_计算异形'
      //   : paibanWayStr,
      // paibanKey: store.state.paibanKey,
      filterObj: filterObjUrl,
      highgloss_direction: ncSetting.value.highgloss_direction,
      // preLayoutSettingUrl:
      //   otherData && otherData.preLayoutSettingUrl
      //     ? otherData.preLayoutSettingUrl
      //     : undefined,
      // batch: store.state.orderInfo.batch
      //   ? Object.keys(store.state.orderInfo.batch).every((key) => {
      //       return store.state.orderInfo.batch[key] > 0
      //     })
      //   : false,
      // used_area: jsonObj.paibanData[0].usedArea,
      batch: jsonObj.paibanInfo.batch,
      paibanKey: jsonObj.paibanInfo.paibanKey,
      paibanWay: jsonObj.paibanInfo.paibanWay,
      is_des_material_no_cut: currentLine?.is_des_material_no_cut,
      material_keywords_list: currentLine?.material_keywords_list,
      hasSpecialBigPlank: jsonObj.paibanData.some((plank) =>
        isSpecialBigPlank(plank)
      ),
      hasSurplusBigPlank: jsonObj.paibanData.some((plank) =>
        isSurplusBigPlank(plank)
      ),
      hasMixPaibanPlans: !!mixPaibanPlans.length,
    },
    process_setting_id: currentRow.value.part.process_line_id ?? -2,
    order_list: store.state.orderInfo.order_ids
      ? store.state.orderInfo.order_ids.split(',').map(Number)
      : [],
    file_type: 'paiban',
    save_node: 3,
    generate_batch: store.state.orderInfo.batch
      ? Object.keys(store.state.orderInfo.batch).every((key) => {
          return store.state.orderInfo.batch[key] > 0
        })
      : false,
    trimSide: ncSetting.value.trimSide ?? '',
    generate_batch_num: currentRow.value.part.layout_batch,
    auto_save: 1,
    // layout_batch: currentRow.value.part.layout_batch,
  }
  await saveHistory(obj)
}

return { __sfc: true,state, isLoading, isFileDownLoad, isBatchDownLoad, isVisible, deleteList, allSelect, ListLen, alreadySelect, repeatNameList, repeatFileNameList, repeatFolderNameList, isShowWarningModal, currentIndex, currentPage, folderChooseModalRef, currentRow, folderExeCb, t, ct, handleReload, onSearch, getProductionFileList, handleDeleteFile, handleConfrimDetale, onAllSelectChange, genPartUniqueId, getSearchInfo, handleGoToBujian, handleClickSingleDownload, handleDownloadFile, handleDownloadNCFile, ncSetting, downloadFile, downloadFullZipFile, handleDownloadFiles, generatePlankListFromPaibanData, saveMaterialPaiban, GBaseModal, GFolderChooseModal, GWarningModal, virtualList, productionFillManageList, MTemplate, productSearchKeys }
}

})